import {
  LC_PAGE_SUBJECT_CHAR_LIMIT,
  SUMMATIVETEST_ENABLED_FORMATS,
} from '@lessonPlanner/constants';

import { SelectField, TextField } from '../form-fields';
import TopicsSection from '../organisms/TopicsSection';
import { GradeLevelDropdown } from '../Select';

import TranslationDropdown from '../../components/molecules/TranslationDropdown';
import FORM_KEYS from '../../constants/forms/summative-test/formKeys';
import processInput from '../../utils/formInput';

export default function LocalST({
  errors,
  watchedValues,
  setValue,
  triggerValidation,
  topicsList,
}: {
  errors;
  watchedValues;
  setValue;
  triggerValidation;
  formState;
  topicsList;
}) {
  const { subject, format, topics = [], language } = watchedValues;

  async function updateFieldValue(fieldName, value) {
    setValue(fieldName, value);
  }

  const curriculumError = {
    error: !!errors.format,
    errorMessage: !!errors.format && 'Please select the format',
  };

  return (
    <>
      <SelectField
        className="col-span-full"
        error={curriculumError.error}
        errorMessage={curriculumError.errorMessage}
        id={FORM_KEYS.format}
        label="Curriculum"
        name={FORM_KEYS.format}
        value={format}
        onBlur={() => triggerValidation(FORM_KEYS.format)}
        onChange={(value) => updateFieldValue(FORM_KEYS.format, value)}
      >
        {SUMMATIVETEST_ENABLED_FORMATS.map((format) => {
          return (
            <option key={format} value={format}>
              {format}
            </option>
          );
        })}
      </SelectField>
      <TextField
        className="col-span-full"
        errorMessage={!!errors.subject && 'Please enter the Subject'}
        id={FORM_KEYS.subject}
        isMaxLengthReached={subject?.length >= LC_PAGE_SUBJECT_CHAR_LIMIT}
        label="Subject"
        maxLength={LC_PAGE_SUBJECT_CHAR_LIMIT}
        name={FORM_KEYS.subject}
        placeholder={'Input the subject for this test'}
        type="subject"
        value={subject}
        onBlur={() => {
          processInput(
            updateFieldValue,
            triggerValidation,
            FORM_KEYS.subject,
            subject?.trim() || '',
          );
          topicsList.triggerGradualValidation('subject');
        }}
        onChange={(e) =>
          processInput(
            updateFieldValue,
            triggerValidation,
            FORM_KEYS.subject,
            e.target.value,
          )
        }
      />

      <GradeLevelDropdown
        error={!!errors.gradeLevel}
        errorMessage={!!errors.gradeLevel && 'Please select the Grade Level'}
        value={watchedValues.gradeLevel}
        onBlur={() => topicsList.triggerGradualValidation('gradeLevel')}
        onChange={(value) => updateFieldValue(FORM_KEYS.gradeLevel, value)}
      />

      <TopicsSection
        addSubtopic={topicsList.addSubtopic}
        addTopic={topicsList.addTopic}
        emptySubtopicsIndex={topicsList.emptySubtopicsIndex}
        errors={errors}
        handleSubtopicChange={topicsList.handleSubtopicChange}
        handleTrimUpdate={topicsList.handleTrimUpdate}
        isTopicEmpty={topicsList.isTopicEmpty}
        removeSubtopic={topicsList.removeSubtopic}
        removeTopic={topicsList.removeTopic}
        showSubtopics={topicsList.showSubtopics}
        toggleSubtopicsVisibility={topicsList.toggleSubtopicsVisibility}
        topics={topics}
        handleTopicChange={(topicIndex, value) => {
          topicsList.handleTopicChange(topicIndex, value);
          topicsList.debouncedValidation('topics');
        }}
      />

      <TranslationDropdown
        errors={errors}
        handleTriggerValidation={triggerValidation}
        handleUpdateFieldValue={updateFieldValue}
        language={language}
      />
    </>
  );
}
